import { cn } from "@/lib/utils";

export const OptionSelector = ({ label, options, value, onChange, disabled, testId }) => {
  return (
    <div className="space-y-2.5" data-testid={testId}>
      <div className="flex items-center gap-2">
        <span className="text-sm font-semibold text-[#24255b]">{label}</span>
        {disabled && (
          <span className="text-[11px] font-medium text-[#6c6d85] bg-[#f4f5fa] px-2 py-0.5 rounded-full">
            No aplica
          </span>
        )}
      </div>
      <div
        className={cn(
          "grid gap-2",
          options.length === 3 ? "grid-cols-3" : "grid-cols-2"
        )}
      >
        {options.map((opt) => {
          const active = opt.value === value;
          return (
            <button
              key={String(opt.value)}
              type="button"
              disabled={disabled}
              onClick={() => !disabled && onChange(opt.value)}
              data-testid={`${testId}-opt-${opt.value}`}
              className={cn(
                "flex flex-col items-center justify-center rounded-xl border px-3 py-3 text-center transition-all duration-200",
                "focus:outline-none focus:ring-2 focus:ring-[#24255b]/30",
                active
                  ? "border-[#24255b] bg-[#24255b] text-white shadow-md shadow-[#24255b]/20"
                  : "border-[#e6e7f0] bg-white text-[#3a3b52] hover:border-[#24255b]/40 hover:bg-[#f4f5fa]",
                disabled && "opacity-50 cursor-not-allowed hover:border-[#e6e7f0] hover:bg-white"
              )}
            >
              <span className="text-sm font-semibold leading-tight">{opt.label}</span>
              {opt.sub && (
                <span className={cn("text-[11px] mt-0.5", active ? "text-white/70" : "text-[#6c6d85]")}>
                  {opt.sub}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};
